<template>
  <div class="register">
    <b-container fluid>
      <div class="d-flex justify-content-center mt-2 mr-4 ml-4">
        <img class="logo-oem" alt="OMEGA EUROPEAN MASTERS" src="../assets/img/logo-2019.svg">
      </div>
      <h4 class="text-center mt-3 mb-0">{{ title }}</h4>
      <div class="oem-card-user text-center">
        <div class="oem-card-user-info mb-4 mt-0">
          <div class="oem-card-user-id-label">{{ $t('reference') }} :
            {{ this.$store.getters.reference.split('-')[0] }}
          </div>
          <div class="oem-card-user-id-label">{{ $t('partner') }} : {{ this.$store.getters.partner }}</div>
          <div class="oem-card-user-id-label">{{ $t('date') }} : {{ this.$store.getters.date }}</div>
          <div class="oem-card-user-name" v-if="this.$store.getters.guest !== ''">{{ $t('guest') }} :
            {{ this.$store.getters.guest }}
          </div>
          <img v-if="this.$store.getters.logoPartner !== ''"
               style="width: 50px; height: auto; display: block; margin:auto;"
               :src="this.$store.getters.logoPartner"/>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div class="oem-zones-editor">
          <form class="oem-zone-save-form" v-on:submit.prevent="onSubmit">
            <b-form-checkbox
                class="mb-3"
                v-model="zone.status"
                name="checkbox-1" :value="true"
                :unchecked-value="false"
                :disabled="!zone.change"
                v-for="zone in this.$store.getters.zones" :key="zone.zone">
              {{ zone.zone }}
            </b-form-checkbox>
            <b-button class="mt-4" block type="submit">{{ $t('save') }}</b-button>
          </form>
          <b-button class="mt-4" block type="button" :to="'/'">{{ $t('scan_again') }}</b-button>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import BContainer from "bootstrap-vue/src/components/layout/container";
import axios from 'axios';

export default {
  name: 'register',
  data: function () {
    return {
      title: 'Carte d\'accès',
    }
  },
  components: {
    BContainer
  },
  methods: {
    async onSubmit() {

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };

      var isNeutre = this.$store.getters.partner === 'Neutres';

      var response = await axios.post('https://access-admin.omegaeuropeanmasters.com/en/scan/save',
          // var response = await axios.post('http://localhost:8000/en/scan/save',
          {
            reference: this.$store.getters.reference,
            zones: this.$store.getters.zones,
            changePartner: isNeutre,
            username: this.$store.getters.username
          },
          {
            headers: headers
          });

      var card = response.data.card;
      this.$store.dispatch('updateCard', card);
      this.$store.dispatch('updateMsg', this.$t('saved_changes'));
      this.$router.push('details');
    },
    async onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('partners');
    }
  },
  mounted() {
    if (!this.$store.getters.isLogged)
      this.$router.push('./');
    if (!this.$store.getters.reference)
      this.$router.push('./');
  }
}
</script>
